export default class PlatformUserModel {
    constructor() {
        this._id = null;
        this._name = null;
        this._completionStatus = null;
        this._sessionId = null;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get completionStatus() {
        return this._completionStatus;
    }

    set completionStatus(value) {
        this._completionStatus = value;
    }

    get sessionId() {
        return this._sessionId;
    }

    set sessionId(value) {
        this._sessionId = value;
    }
}

PlatformUserModel.COMPLETION_STATUS = {
    UNKNOWN: 'unknown',
    NOT_STARTED: 'not_started',
    INCOMPLETE: 'incomplete',
    COMPLETED: 'completed'
}